import React, { useRef } from 'react';
import { useDisableMapEvents } from '../hooks/useDisableMapEvents';

export default function PlumeEmissionLegend() {
  const ref = useRef(null);
  useDisableMapEvents(ref);

  const rowStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  };

  const iconWrapperStyle = {
    width: 32,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const squareStyle = (size, background) => ({
    width: size,
    height: size,
    background,
    border: '2px solid white',
    boxShadow: '0 0 4px rgba(0,0,0,0.4)',
  });

  return (
    <div
      ref={ref}
      className="map-card"
      style={{ padding: '10px 14px' }}
    >
      <div className="map-card-title">
        Emission points
      </div>

      {/* Normal */}
      <div style={rowStyle}>
        <div style={iconWrapperStyle}>
          <div style={squareStyle(12, '#7a0403')} />
        </div>
        Emission point
      </div>

      {/* Selected */}
      <div style={{ ...rowStyle, marginTop: 6 }}>
        <div style={iconWrapperStyle}>
          <div style={squareStyle(15, '#ff2d2d')} />
        </div>
        Selected emission point
      </div>

      {/* Active */}
      <div style={{ ...rowStyle, marginTop: 6 }}>
        <div style={iconWrapperStyle}>
          <div style={{ position: 'relative', width: 18, height: 18 }}>
            <div
              style={{
                position: 'absolute',
                width: 26,
                height: 26,
                borderRadius: '50%',
                background: 'rgba(0,81,153,0.25)',
                top: -4,
                left: -4
              }}
            />
            <div style={squareStyle(18, '#005199')} />
          </div>
        </div>
        Plume calculated
      </div>
    </div>
  );
}
